import React from "react";

import { Stack } from "@mui/material";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

interface Props {
  isOpen: boolean;
  isMutating: boolean;
  closeModal: () => void;
  onConfirm: () => void;
  isCurrentlyTrading: boolean;
}

const disabledTrading = `Beginning with the next daily trading cycle, Farther will no longer execute any trades for this account.`;
const enabledTrading = `Beginning with the next daily trading cycle, Farther will evaluate this account for rebalancing and trades will be executed as necessary. This evaluation will be done on a daily basis. `;

const TradingModalV2 = (props: Props): JSX.Element => {
  return (
    <Modal
      isOpen={props.isOpen}
      closeModal={props.closeModal}
      modalStyle={{ width: "520px" }}
    >
      <Text variant="title2" style={{ paddingBottom: 8 }}>
        {props.isCurrentlyTrading ? "Disable trading?" : "Enable trading?"}
      </Text>

      <Text variant="body" color="textSubtle" style={{ paddingBottom: 32 }}>
        {props.isCurrentlyTrading ? disabledTrading : enabledTrading}
      </Text>
      <Stack direction={"row"} spacing={2}>
        <Button
          sx={{ flex: 1 }}
          style={{ width: "100%" }}
          variant={"outlined"}
          buttonType={"secondary"}
          text={"Cancel"}
          onClick={props.closeModal}
        />
        <Button
          variant={"contained"}
          buttonType={"primary"}
          text={"Confirm"}
          onClick={props.onConfirm}
          style={{ width: "100%" }}
          sx={{ flex: 1 }}
        />
      </Stack>
      {props.isMutating && <LogoLoadingStill onTop={true} />}
    </Modal>
  );
};

export default TradingModalV2;
